/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minimum_Frame_GapInputs */

const en_minimum_frame_gap = /** @type {(inputs: Minimum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum Frame Gap`)
};

const fr_minimum_frame_gap = /** @type {(inputs: Minimum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écart minimal entre images`)
};

const de_minimum_frame_gap = /** @type {(inputs: Minimum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimaler Rahmenabstand`)
};

const it_minimum_frame_gap = /** @type {(inputs: Minimum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distanza minima tra i telai`)
};

const ru_minimum_frame_gap = /** @type {(inputs: Minimum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минимальный зазор между кадрами`)
};

const es_minimum_frame_gap = /** @type {(inputs: Minimum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacio mínimo entre marcos`)
};

const zh_cn2_minimum_frame_gap = /** @type {(inputs: Minimum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小帧间隙`)
};

const ja_minimum_frame_gap = /** @type {(inputs: Minimum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小フレームギャップ`)
};

const hi_minimum_frame_gap = /** @type {(inputs: Minimum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`न्यूनतम फ्रेम अंतर`)
};

const pt_pt2_minimum_frame_gap = /** @type {(inputs: Minimum_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaço mínimo entre quadros`)
};

/**
* | output |
* | --- |
* | "Minimum Frame Gap" |
*
* @param {Minimum_Frame_GapInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const minimum_frame_gap = /** @type {((inputs?: Minimum_Frame_GapInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minimum_Frame_GapInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_minimum_frame_gap(inputs)
	if (locale === "de") return de_minimum_frame_gap(inputs)
	if (locale === "it") return it_minimum_frame_gap(inputs)
	if (locale === "ru") return ru_minimum_frame_gap(inputs)
	if (locale === "es") return es_minimum_frame_gap(inputs)
	if (locale === "zh-CN") return zh_cn2_minimum_frame_gap(inputs)
	if (locale === "ja") return ja_minimum_frame_gap(inputs)
	if (locale === "hi") return hi_minimum_frame_gap(inputs)
	if (locale === "pt-PT") return pt_pt2_minimum_frame_gap(inputs)
	return en_minimum_frame_gap(inputs)
});